import { Button, Modal } from '@bfe/moly';
import { GoogleIcon } from '@bfe/moly-icons';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useI18nContext } from '@/i18n/I18n';
import { isMobile } from '@/utils/ua';

import styles from './index.module.less';

export const Google2faModal: FC<{
  showGoogle2faModal: boolean;
  onCancel: () => void;
  onOk: () => void;
  isNavigate?: boolean;
}> = ({ showGoogle2faModal, onCancel, onOk, isNavigate = true }) => {
  const [$t] = useI18nContext();
  const navigate = useNavigate();

  const goOpenGoogle2fa = () => {
    isNavigate && navigate('/app/user/security');
    onOk();
  };

  return (
    <Modal
      open={showGoogle2faModal}
      title={$t('Security Verification')}
      onCancel={onCancel}
      width={480}
      footer={false}
      isMobile={isMobile()}
    >
      <div>{$t('openGoogle2faTip')}</div>
      <div className={styles.googleTip}>
        <span style={{ marginTop: 3 }}>
          <GoogleIcon />
        </span>
        <span className={styles.googleTipTitle}>
          {$t('googleAuthenticator')}
        </span>
        <span className={styles.googleTipStatus}>{$t('notOpen')}</span>
      </div>
      <Button
        variant="primary"
        size="large"
        className="w-full"
        style={{ marginTop: 24 }}
        onClick={goOpenGoogle2fa}
      >
        {$t('goOpen')}
      </Button>
    </Modal>
  );
};

export default Google2faModal;
